import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import history from 'app/routes/history';


import { Badge } from 'reactstrap';
import Table from 'app/components/general/Table';
import Button from 'app/components/general/Button';

import * as paymentsSelectors from 'app/ducks/payments/selectors';

const constructPaymentsData = (paymentsById, paymentIds) => {
  if (
    paymentsById !== undefined
    && !_.isEmpty(paymentsById)
    && paymentIds !== undefined
  ) {
    const paymentRows = _.reduce(
      paymentIds,
      (acc, id) => {
        if (!_.isEmpty(paymentsById[id])) {
          acc.push(paymentsSelectors.getPaymentSummary(paymentsById[id]));
        }
        return acc;
      },
      [],
    );

    return paymentRows;
  }
  return [];
};

const onFetchData = async (props, state, instance) => {
  const { pageSize } = state;
  const pageNumber = state.page;
  const sort = instance.state.sorted;
  const filter = state.filtered;
  // console.log(props, filter);

  if (
    props.appReady
    && !props.isLoading
    && (pageNumber !== props.pagination.page.number
      || (!_.isEmpty(sort) && sort !== props.pagination.sort)
      || filter !== props.pagination.filter)
  ) {
    await props.actions.getAllPayments({
      page: {
        size: pageSize,
        number: pageNumber,
      },
      sort,
      filter,
    });
  }
};

const PaymentsTable = (props) => {
  const data = constructPaymentsData(props.paymentsById, props.paymentIds);

  const columns = [
    {
      Header: 'Description',
      accessor: 'description',
      className: 'col',
      headerClassName: 'col',
    },
    {
      Header: 'Status',
      className: 'col',
      headerClassName: 'col',
      accessor: 'status',
      Cell: (cellProps) => (
        <span
          className={classnames(
            {
              'color-green': cellProps.value.includes('Up to Date'),
            },
            {
              'color-grey': cellProps.value.includes('Owing'),
            },
            {
              'color-red': cellProps.value.includes('Overdue'),
            },
          )}
        >
          {cellProps.value}
        </span>
      ),
    },
  ];

  const filterOptions = [
    {
      label: 'Name',
      accessor: 'name',
      type: 'text',
    },
    {
      label: 'Amount',
      accessor: 'amount',
      type: 'text',
    },
    {
      label: 'Status',
      accessor: 'status',
      type: 'select',
      options: [
        { id: 'owing', name: 'Owing' },
        { id: 'overdue', name: 'Overdue' },
        { id: 'none', name: 'Up to Date' },
      ],
    },
  ];

  return (
    <Table
      headerTitle={props.headerTitle}
      objectTitle="payments"
      filterTitle="Payments Data"
      isLoading={props.isLoading}
      data={data}
      columns={columns}
      manual={props.manual}
      showPagination={false}
      onFetchData={(state, instance) => onFetchData(props, state, instance)}
      filterOptions={filterOptions}
      filterConfig={props.initialFilterConfig}
      persistentFilterConfig={props.persistentFilterConfig}
      pagination={props.pagination}
      handleClick={(paymentId) => {
        props.selectPayment(paymentId);
        history.push(`/payments/${paymentId}`);
      }}
    >
      <Button onClick={props.handleCreate} className="btn-thinner btn-2">
        Request Payment
      </Button>
    </Table>
  );
};

PaymentsTable.propTypes = {
  competitionId: PropTypes.string,
  paymentsById: PropTypes.object,
  paymentIds: PropTypes.array,
  headerTitle: PropTypes.string,
  initialFilterConfig: PropTypes.object,
  persistentFilterConfig: PropTypes.object,
  isLoading: PropTypes.bool,
  pagination: PropTypes.object,
  manual: PropTypes.bool,
  selectPayment: PropTypes.func,
  handleCreate: PropTypes.func,
};

PaymentsTable.defaultProps = {
  competitionId: undefined,
  paymentsById: undefined,
  paymentIds: undefined,
  headerTitle: undefined,
  initialFilterConfig: undefined,
  persistentFilterConfig: undefined,
  isLoading: false,
  manual: true,
  pagination: undefined,
  selectPayment: undefined,
  handleCreate: undefined,
};

export default PaymentsTable;
